exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".JobStatus .fa {\n  margin-right: 5px;\n}\n", ""]);

// exports
